import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
/**
 * Minimal accessible modal/dialog shared by both personalities — used for e.g. a
 * till-side "confirm void" prompt as much as an Accountant-panel "create account" form.
 * Deliberately dependency-free (no portal library): renders a fixed-position overlay and
 * relies on the caller mounting it near the root so `position: fixed` behaves
 * predictably; consuming apps with their own portal/stacking-context conventions can
 * wrap this in their own `createPortal` call without needing changes here.
 */
export function Modal({ open, onClose, title, children, footer }) {
    useEffect(() => {
        if (!open)
            return;
        function handleKeyDown(event) {
            if (event.key === "Escape")
                onClose();
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: "sl-modal-overlay", role: "presentation", onClick: onClose, children: _jsxs("div", { className: "sl-modal", role: "dialog", "aria-modal": "true", "aria-label": title, onClick: (event) => event.stopPropagation(), children: [title ? _jsx("h2", { className: "sl-modal__title", children: title }) : null, _jsx("div", { className: "sl-modal__body", children: children }), footer ? _jsx("div", { className: "sl-modal__footer", children: footer }) : null] }) }));
}
//# sourceMappingURL=Modal.js.map